/* Mint-Files › tab=lib / media. Màu chỉ var(--…). */
.title { font-size: 15px; font-weight: var(--fw-title); }
.sub { font-size: 12px; color: var(--lb); }
.chip { display: inline-flex; align-items: center; gap: 4px; height: 30px; padding: 0 10px; border: 0; border-radius: 999px; background: var(--pri-bg); color: var(--link); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; }
.bulk { background: var(--pri-bg); }
.bulk b { color: var(--link); font-weight: var(--fw-label); margin-right: 6px; }
.notice { flex-shrink: 0; display: flex; align-items: center; gap: 10px; margin-top: 28px; padding: 10px 14px; border-radius: 12px; background: var(--pri-bg); color: var(--tx); box-shadow: inset 0 0 0 1px var(--pri-bd); font-size: 13px; }
.notice > svg { color: var(--link); flex-shrink: 0; }
.notice b { font-weight: var(--fw-label); }
.ro { margin: 10px 14px 0; padding: 10px 12px; border-radius: 12px; background: var(--sub); font-size: 12px; color: var(--tx2); }
.ro b { color: var(--tx); }
.afterBanner { margin-top: 12px; }
.w104 { width: 104px; flex-shrink: 0; }
.w56 { width: 56px; flex-shrink: 0; }
.wrap { color: var(--tx2); }
.box { padding: 12px; border-radius: 14px; background: var(--sub); }
.box h3 { margin: 0 0 6px; font-size: 14px; font-weight: var(--fw-title); }
.vRow { padding: 6px 0; border-top: 1px solid var(--line); }
.vRow:first-of-type { border-top: 0; }
.w128 { width: 128px; flex-shrink: 0; }
.w112 { width: 112px; flex-shrink: 0; }
.aside { width: 320px; flex-shrink: 0; box-sizing: border-box; padding: 16px 14px; border-radius: 16px; background: var(--card); box-shadow: var(--sh); overflow-y: auto; }
.panel { display: flex; flex-direction: column; gap: 12px; font-size: 13px; }
.pHead { display: flex; align-items: flex-start; gap: 8px; }
.pHead h2 { margin: 0; font-size: 16px; font-weight: var(--fw-title); line-height: 1.3; }
.pFile { margin-top: 2px; font-size: 12px; color: var(--lb); word-break: break-all; }
.pChips { display: flex; flex-wrap: wrap; gap: 6px; }
.pType { padding: 3px 9px; border-radius: 999px; font-size: 12px; font-weight: var(--fw-label); background: var(--pri-bg); color: var(--link); }
.pBtns { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; }
.pBtns2 { display: flex; gap: 8px; }
.pBtns2 > * { flex: 1 1 0; }
.ai { padding: 12px 14px; border-radius: 14px; background: var(--pri-bg); box-shadow: inset 0 0 0 1px var(--pri-bd); color: var(--tx2); }
.aiH { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; font-weight: var(--fw-label); color: var(--link); }
.dl { margin: 0; display: grid; gap: 7px; }
.dlRow { display: grid; grid-template-columns: 96px 1fr; gap: 10px; }
.dl dt { color: var(--lb); }
.dl dd { margin: 0; font-weight: 500; }
.tags { display: flex; flex-wrap: wrap; gap: 6px; }
.tags span { padding: 2px 8px; border-radius: 999px; font-size: 12px; background: var(--ctl); color: var(--tx2); }

/* Media */
.mPad { padding: 14px 16px; }
.mGrid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.mCard { display: flex; flex-direction: column; padding: 0; border: 0; border-radius: 16px; background: var(--sub); color: var(--tx); font: inherit; text-align: left; cursor: pointer; overflow: clip; }
.mosaic2 { height: 140px; width: 100%; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 2px; }
.mBody { padding: 10px 12px 12px; display: flex; flex-direction: column; gap: 2px; }
.mBody b { font-weight: var(--fw-label); }
.mMeta { font-size: 12px; color: var(--lb); }
.mWarn { font-size: 12px; color: var(--warn); }
.feed { max-width: 760px; margin: 0 auto; display: flex; flex-direction: column; gap: 14px; }
.post { border-radius: 16px; background: var(--sub); overflow: clip; }
.postH { display: flex; align-items: center; gap: 10px; padding: 12px 14px; }
.ab { width: 32px; height: 32px; border-radius: 10px; background: var(--card); display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: var(--fw-title); }
.postT b { font-weight: var(--fw-label); }
.postT span { color: var(--tx2); }
.postW { font-size: 12px; color: var(--lb); }
.mosaic4 { width: 100%; height: 220px; padding: 0; border: 0; display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 2px; background: transparent; cursor: pointer; }
.postF { display: flex; align-items: center; gap: 8px; padding: 10px 14px; }
.postN { margin-left: auto; font-size: 12px; color: var(--lb); }
.photos { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; }
.photo { position: relative; height: 150px; border-radius: 12px; overflow: clip; }
.aiSc { position: absolute; top: 8px; right: 8px; padding: 1px 7px; border-radius: 999px; font-size: 11px; font-weight: var(--fw-title); background: var(--card); color: var(--tx); }
.by { position: absolute; right: 8px; bottom: 8px; font-size: 11px; font-weight: var(--fw-label); color: var(--on-img, #fff); } /* token-ok: chữ trắng trên ảnh */
.cover { position: absolute; left: 8px; bottom: 8px; padding: 1px 7px; border-radius: 999px; font-size: 11px; font-weight: var(--fw-title); background: var(--card); color: var(--tx); }
.act { display: flex; gap: 8px; padding: 7px 0; border-top: 1px solid var(--line); }
.act:first-of-type { border-top: 0; }
.dot { width: 8px; height: 8px; margin-top: 6px; flex-shrink: 0; border-radius: 50%; background: var(--pri); }
.actW { font-size: 12px; color: var(--lb); }

.lbBtn { display: flex; align-items: center; gap: 8px; height: 36px; margin-top: 8px; padding: 0 10px; border: 0; border-radius: 10px; background: var(--sub); color: var(--tx); font: inherit; font-weight: var(--fw-label); text-align: left; cursor: pointer; white-space: nowrap; }
.lbTable { width: 100%; border-collapse: collapse; font-size: 13px; }
.lbTable th { height: 30px; text-align: left; font-size: 12px; font-weight: var(--fw-label); color: var(--lb); }
.lbTable td { height: 40px; border-top: 1px solid var(--line); }
